import * as tenantConfigs from '../config/clients';

type Tenants = 'goodrx' | 'heydoctor' | 'gold';

class Tenancy {
  client: Tenants;

  isHeyDoctor = () => this.getTenant() === 'heydoctor';

  isGoodRx = () => this.getTenant() === 'goodrx';

  isGold = () => this.getTenant() === 'gold';

  getName = () => this.getConfig().Name;

  getConfig = () => tenantConfigs[this.getTenant()];

  getLogoSrc() {
    const tenant = this.getTenant();
    const config = this.getConfig();
    const filename = config.LandscapeLogoKey ? config.LandscapeLogoKey : `${tenant}.landscape.svg`;
    return `https://cdn.heydoctor.com/images/logos/${filename}`;
  }

  /* eslint-disable-next-line class-methods-use-this */
  getTenant() {
    return (process.env.CLIENT || 'heydoctor') as Tenants;
  }

  getBaseUrl = () => this.getConfig().BaseUrl;
}

export const tenancy = new Tenancy();
export default tenancy;
